import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doDEVELOPER_TOKEN_LIST_SET } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_DEVELOPER_TOKEN_LIST_FETCH = "REQUEST_DEVELOPER_TOKEN_LIST_FETCH";
export const doREQUEST_DEVELOPER_TOKEN_LIST_FETCH = createDoRequestAction(
  REQUEST_DEVELOPER_TOKEN_LIST_FETCH,
);

export const requestDeveloperTokenListFetchActionCreators = {
  doREQUEST_DEVELOPER_TOKEN_LIST_FETCH,
};

export function* requestDeveloperTokenListFetch({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*requestDeveloperTokenListFetch");
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        page: v.number().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_DEVELOPER_TOKEN_LIST_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { page } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/developer-token-list-fetch`,
    accessToken,
    data: {
      page,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_DEVELOPER_TOKEN_LIST_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/developer-token-list-fetch",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doDEVELOPER_TOKEN_LIST_SET(result.payload));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_DEVELOPER_TOKEN_LIST_FETCH,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* developerTokenListFetchSaga() {
  yield takeEvery(REQUEST_DEVELOPER_TOKEN_LIST_FETCH as any, requestDeveloperTokenListFetch);
}
